// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3A-5Z","content":"styles_content__1w3Ia","selectAll":"styles_selectAll__1zqvr"};